import classNames from "classnames";
import { Location } from "history";
import * as React from "react";
import { Link } from "react-router-dom";

import withLocaleLink from "features/common/containers/withLocaleLink";

import styles from "../../../ClickableText.module.scss";
import { Color, COLORS } from "../../../consts";

type Props = {
  id?: string;
  to: string | Location;
  text?: string;
  children?: React.ReactNode;
  isExternal?: boolean;
  onClick?: () => void;
  underlineOnHover?: boolean;
  className?: string;
  color?: Color | null | undefined | string;
  linkClassName?: string;
};

class TextLink extends React.PureComponent<Props> {
  static defaultProps = {
    isExternal: false,
    underlineOnHover: false
  };

  render() {
    const { id, isExternal, to, onClick, linkClassName } = this.props;

    if (isExternal) {
      return (
        <a
          id={id}
          href={to as string}
          onClick={onClick}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className={classNames(styles.removeLinkTextDecoration, linkClassName)}
        >
          {this.renderTextElement()}
        </a>
      );
    }

    return (
      <Link
        id={id}
        to={to}
        onClick={onClick}
        className={classNames(styles.removeLinkTextDecoration, linkClassName)}
      >
        {this.renderTextElement()}
      </Link>
    );
  }

  renderTextElement() {
    const { text, className, underlineOnHover, children, color } = this.props;
    return (
      <span
        data-test="TextLink__Link"
        className={classNames(className, {
          [styles.blueText]: !color,
          [styles.greyText]: color === COLORS.GREY,
          [styles.whiteText]: color === COLORS.WHITE,
          [styles.blackText]: color === COLORS.BLACK,
          [styles.skyBlue]: color === COLORS.SKY_BLUE,
          [styles.underlineOnHover]: underlineOnHover,
          [styles.removeUnderlineOnHover]: !underlineOnHover
        })}
      >
        {children ? children : text}
      </span>
    );
  }
}

export default TextLink;

export const TextLinkWithLocale = withLocaleLink(TextLink);
